var map = {
	"./cs-Czech-mac.json": 42277,
	"./cs-Czech-pc.json": 40522,
	"./da-Danish-mac.json": 27261,
	"./da-Danish-pc.json": 54493,
	"./de-German-mac.json": 8091,
	"./de-German-pc.json": 17630,
	"./de-Swiss_German-mac.json": 97851,
	"./de-Swiss_German-pc.json": 33722,
	"./en-British-mac.json": 48387,
	"./en-British-pc.json": 90969,
	"./en-Colemak-mac.json": 49050,
	"./en-Dvorak-mac.json": 51408,
	"./en-Dvorak-pc.json": 74470,
	"./en-Dvorak_Lefthanded-mac.json": 18456,
	"./en-Dvorak_Lefthanded-pc.json": 50994,
	"./en-Dvorak_Righthanded-mac.json": 89933,
	"./en-Dvorak_Righthanded-pc.json": 53331,
	"./en-US-mac.json": 83985,
	"./en-US-pc.json": 49882,
	"./es-Spanish-mac.json": 68545,
	"./es-Spanish-pc.json": 71928,
	"./fr-Bepo-pc.json": 43280,
	"./fr-Canadian_French-mac.json": 58812,
	"./fr-Canadian_French-pc.json": 22076,
	"./fr-French-mac.json": 76185,
	"./fr-French-pc.json": 31766,
	"./fr-Swiss_French-mac.json": 63689,
	"./fr-Swiss_French-pc.json": 58922,
	"./hu-Hungarian-mac.json": 11308,
	"./hu-Hungarian-pc.json": 67324,
	"./it-Italian-mac.json": 21383,
	"./it-Italian-pc.json": 94479,
	"./nb-Norwegian-mac.json": 38122,
	"./nb-Norwegian-pc.json": 84336,
	"./nl-Dutch-mac.json": 30205,
	"./nl-Dutch-pc.json": 37468,
	"./pl-Polish-mac.json": 6289,
	"./pl-Polish-pc.json": 83162,
	"./pt-Brazilian-mac.json": 74855,
	"./pt-Portuguese-mac.json": 70207,
	"./pt-Portuguese-pc.json": 90714,
	"./ro-Romanian-mac.json": 33051,
	"./ro-Romanian-pc.json": 12618,
	"./sv-Swedish-mac.json": 46693,
	"./sv-Swedish-pc.json": 18790,
	"./tr-Turkish_Q-mac.json": 25882,
	"./tr-Turkish_Q-pc.json": 30399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1840;